export default "__VITE_ASSET__CzjjWkOD__"